import { IAppSetting } from '@addins/core/core';
import { ListSettingWithNames } from '@addins/core/settings/views/settings-editor/settings-editor.component';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppSettingProviderService, StatusChangeViewPosition } from '@services/settings';
import { Subscription } from 'rxjs';
import { ListSettingValue } from '../../schema/list-setting-value';
import { SettingValue } from '../../schema/setting-value';

const settingValues: SettingValue[] = [
  new SettingValue('Mobile.Top', StatusChangeViewPosition.Top),
  new SettingValue('Mobile.Right', StatusChangeViewPosition.Right),
  new SettingValue('Mobile.Bottom', StatusChangeViewPosition.Bottom)
];

@Component({
  selector: 'app-status-change-view-settings',
  templateUrl: './status-change-view-settings.component.html',
  styleUrls: ['./status-change-view-settings.component.scss']
})
export class StatusChangeViewSettingsComponent implements OnInit, OnDestroy {
  private currentStatusChangeViewPosition: IAppSetting<string> = null;
  private currentStatusChangeViewPositionSub: Subscription;

  private _statusChangeViewPositionSettings: ListSettingWithNames;
  get statusChangeViewPositionSettings(): ListSettingWithNames {
    return this._statusChangeViewPositionSettings;
  }

  constructor(private appSettingProvider: AppSettingProviderService) {}

  ngOnInit() {
    this.appSettingProvider.getStatusChangeViewPosition().subscribe(appSetting => this.onStatusChangeViewPositionSettingReady(appSetting));
  }

  private onStatusChangeViewPositionSettingReady(appSetting: IAppSetting<StatusChangeViewPosition>) {
    this.currentStatusChangeViewPosition = appSetting;
    this._statusChangeViewPositionSettings = this.createStatusChangeViewPositionSettings(appSetting.current);

    this.currentStatusChangeViewPositionSub = this._statusChangeViewPositionSettings.setting.$change.subscribe(
      (settingValue: SettingValue) => this.handleStatusChangeViewPositionChanged(settingValue.value)
    );
  }

  private createStatusChangeViewPositionSettings(currentValue: StatusChangeViewPosition): ListSettingWithNames {
    const listSettingValue: ListSettingValue = new ListSettingValue('Mobile.StatusChangeViewPosition', settingValues);
    let currentPosition: SettingValue = settingValues.filter(setting => setting.value === currentValue)[0];
    listSettingValue.select(currentPosition);

    return {
      setting: listSettingValue,
      displayNames: {},
      readonly: false
    };
  }

  private handleStatusChangeViewPositionChanged(newValue: StatusChangeViewPosition): void {
    this.currentStatusChangeViewPosition.setValue(newValue);
  }

  ngOnDestroy() {
    this.currentStatusChangeViewPositionSub.unsubscribe();
  }
}
